import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Orderlist = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const user_id = sessionStorage.getItem("userId");

const navigate = useNavigate();
  useEffect(() => {
    if (user_id) {
      fetchOrders();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/list_new_order",
        { user_id }
      );

      if (res.data.status === true) {
        setOrders(res.data.orders);
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to view your orders</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading orders...</h5>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h5>No orders found</h5>
      </div>
    );
  }

  // Using first order for header details
  const orderInfo = orders[0];

  return (
    <section className="myntra-order-container py-4">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 col-xl-12">
            <div className="card pb-3">
              {/* Header */}
              <div className="card-header px-4 py-3">
                <h5 className="text-muted mb-0">
                  Thanks for your Order,{" "}
                  <span className="fw-bold">{orderInfo.billing_details?.first_name}</span>!
                </h5>
              </div>
{/* <div className="d-flex justify-content-between align-items-center"> */}
<div className="d-flex flex-column flex-md-row justify-content-between gap-4">
              {/* <div className="card-body p-4"> */}
              <div className="card-body p-4 col-12 col-md-8">
                <p className="fw-bold mb-1">Order Details</p>
                <p className="text-muted mb-1">
                  Placed On: {orderInfo.order_date}
                </p>
                <p className="text-muted mb-1">
                  Order No: <strong>{orderInfo.order_id}</strong>
                </p>
                <p className="text-muted mb-1">
                   Order Status: <strong>{orderInfo.order_status}</strong>
                </p>
                <p className="text-muted mb-1">
                   Payment Mode: <strong>{orderInfo.payment_mode}</strong>
                </p>
                <p className="text-muted mb-1">
                   Payment Status: <strong>{orderInfo.payment_status}</strong>
                </p>
                <p className="text-muted mb-3">
                  Total Amount: <strong className="text-success">₹{orderInfo.total}</strong>
                </p>
                

                {/* <p className="fw-bold mb-1">Payment Mode</p>
                <p className="text-muted mb-3">
                  {orderInfo.payment_mode}
                </p> */}
                {/* <hr />

                <p className="fw-bold mb-3">Items in this Order</p> */}

                {/* PRODUCTS
                {orders.map((item, index) => (
                  <div className="card shadow-sm border mb-4" key={item.order_id}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-2">
                          <img
          src={
            item.parsedImage?.length
              ? `https://cyberathon.com/multivendor/${item.parsedImage[0]}`
              : "https://via.placeholder.com/60"
          }
          alt={item.Product_name}
          className="payment-cart-img"
        />
                        </div>
                        <div className="col-md-10">
                          <h6 className="fw-bold">{item.Product_name}</h6>
                          <p className="mb-1 text-muted">
                            Order Status: <strong>{item.order_status}</strong>
                          </p>
                          <p className="mb-1 text-muted">
                            Payment Status:{" "}
                            <strong>{item.payment_status}</strong>
                          </p>
                          <p className="mb-1">Qty: <strong>{item.product_qty}</strong></p>
                          <p className="fw-bold text-danger">
                            ₹{item.total}
                          </p>
                          <Link to="/ProductReview" style={{textDecoration:"none"}}>
                          <p className="text-primary"><img src="/img/rating.png" style={{width:"15px", paddingBottom:"5px"}} /> <span className="text-primary">Reate & Review Product</span></p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))} */}
              </div>
              {/* <div className="d-flex flex-column align-items-center justify-content-center gap-5">
                
             <button
  className="bg-col border-0 rounded-1 p-3 fw-bold text-light mx-5"
  onClick={() => navigate("/vieworder", { state: { order_id: orderInfo.order_id } })}
>
  View Order
</button>
<button
  className="bg-col border-0 rounded-1 p-3 fw-bold text-light mx-5"
  onClick={() => navigate("/products")}
>
  Continue Shopping
</button>

              </div> */}
              <div className="d-flex flex-row flex-md-column gap-3 w-100 justify-content-center align-items-center ">
  
  <button
    className="bg-col border-0 rounded-1 py-md-3 py-3 fw-bold text-light px-2 px-md-3  w-md-auto "
    onClick={() =>
      navigate("/vieworder", { state: { order_id: orderInfo.order_id } })
    }
  >
    View Order
  </button>

  <button
    className="bg-col border-0 rounded-1 p-3 fw-bold text-light  w-md-auto "
    onClick={() => navigate("/products")}
  >
    Continue Shopping
  </button>

</div>
             
</div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Orderlist;